import axios from 'axios';
import { auth } from './auth';

const api = axios.create({
    baseURL: process.env.VUE_APP_BASE_API_URL || 'http://localhost:3009/v1',
    headers: {
        'Content-Type': 'application/json'
    }
});

// Request Interceptor: ເພີ່ມ Token ເຂົ້າໃນ Header ອັດຕະໂນມັດກ່ອນສົ່ງ Request
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('user-token');
        // ຖ້າມີ Token ແລະ ຍັງບໍ່ມີ Authorization header (ເຊັ່ນ: ກໍລະນີ Login ທີ່ໃຊ້ Basic Auth ຈະບໍ່ໃຫ້ມັນຂຽນທັບ)
        if (token && !config.headers.Authorization) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Response Interceptor: ຈັດການເມື່ອ Token ໝົດອາຍຸ ຫຼື ເຊີເວີຕອບກັບມາວ່າບໍ່ມີສິດ
api.interceptors.response.use(
    (response) => {
        // ຈັດການກໍລະນີ API ສົ່ງ Code ບາງຢ່າງມາບອກວ່າ Session ໝົດອາຍຸ (ຕົວຢ່າງ: code: -1)
        if (response.data && response.data.code === -1) {
            auth.logout();
            window.location.href = '/login';
            return Promise.reject(new Error('Session expired'));
        }
        return response;
    },
    (error) => {
        // ຍົກເວັ້ນ request login: 401/403 ຕອນ login ໝາຍເຖິງລະຫັດຜ່ານຜິດ ບໍ່ແມ່ນ session ໝົດອາຍຸ
        // ຈຶ່ງບໍ່ຄວນ logout ຫຼື redirect — ໃຫ້ LoginPage ຈັດການສະແດງຂໍ້ຄວາມເອງ
        const isLoginRequest = error.config && error.config.url && error.config.url.includes('/login');

        if (!isLoginRequest && error.response && (error.response.status === 401 || error.response.status === 403)) {
            // ເມື່ອ Token ໝົດອາຍຸ ຫຼື ບໍ່ຖືກຕ້ອງ
            auth.logout();
            localStorage.removeItem('user-token');
            localStorage.removeItem('user-info');
            window.location.href = '/login';
        }
        return Promise.reject(error);
    }
);

export default api;